import { RequestActivityRequestType } from './enums'

export const REQUEST_ACTIVITY_DEFAULT_PAGE = 1
/** OpenAPI default is 10; the schema rejects anything above 100. */
// Maximum cap is of 100 events, hence it's safe to hardcode it here with a fixed value.
export const REQUEST_ACTIVITY_MAX_PER_PAGE = 100

export const REQUEST_ACTIVITY_PATHS: Record<RequestActivityRequestType, (requestId: string) => string> = {
  [RequestActivityRequestType.DataAccess]: requestId =>
    `/data-access-requests/verification/${requestId}/review-activity`,
  [RequestActivityRequestType.Export]: requestId => `/results/verification/${requestId}/review-activity`,
  [RequestActivityRequestType.Import]: requestId => `/import-requests/verification/${requestId}/review-activity`
}
